export const obterNomeDoPerfil = (perfil, situacaoCadastroFamilia) => {
    if (!perfil && situacaoCadastroFamilia?.nomeCnis)
      return situacaoCadastroFamilia?.nomeCnis;

    if (!perfil) return;

    let nome = perfil.nome;

    if (perfil.temIdentidadeGenero && perfil.nomeSocialApelidoPessoa) {
        nome = perfil.nomeSocialApelidoPessoa;
    }

    return !!perfil ? nome : situacaoCadastroFamilia?.nomeCnis
}

export const obterNomeDoPerfilComum = (objeto) => {
    let nome = objeto.nome;

    if (objeto.temIdentidadeGenero && objeto.nomeSocialApelidoPessoa) {
        nome = objeto.nomeSocialApelidoPessoa;
    }

    return nome;
}

export const obterNomePessoa = (objeto) => {
    let nomePessoa = objeto.nomePessoa;

    if (objeto.temIdentidadeGenero && objeto.nomeSocialApelidoPessoa) {
        nomePessoa = objeto.nomeSocialApelidoPessoa;
    }

    return nomePessoa;
}
